import Icon from 'veui/components/Icon'
import { IconZoomOut } from 'dls-icons-vue'

Icon.register('zoom-out', IconZoomOut)
